/**
 * Integracje → Kalendarz „Dodaj do Kalendarza Apple" (owner, 28 October 2026): the calendar
 * subscription as a BUTTON — one press opens Calendar's own „Subscribe" dialog on a Mac, iPhone or
 * iPad, and the address is never shown (calendar-sync R10). Offered only on an Apple device and
 * only where the backend has the feed configured. Pure.
 *
 * The feed's own rules (`isWebcalUrl`, `subscribeTarget`) are `entities/calendar-feed`'s since
 * `/rezerwacje`'s card became the second caller; they are re-exported here for this slice.
 */

import type { CalendarFeedRead } from '~/entities/calendar-feed';

import type { GoogleCalendarView } from './googleCalendar';

export { isWebcalUrl, subscribeTarget, type CalendarFeedRead } from '~/entities/calendar-feed';

export type AppleCalendarView =
  | { readonly kind: 'hidden' }
  /** The button; `enabled` adds „Wyłącz link" and „Utwórz nowy". */
  | { readonly kind: 'offer'; readonly enabled: boolean; readonly lastFetchedAt: string | null };

export function appleCalendarView(read: CalendarFeedRead | undefined, apple: boolean): AppleCalendarView {
  if (!apple || read === undefined || !read.available) return { kind: 'hidden' };
  return { kind: 'offer', enabled: read.enabled, lastFetchedAt: read.enabled ? (read.lastFetchedAt ?? null) : null };
}

/**
 * Integracje → Kalendarz says „pick one" when BOTH calendars are offered on screen (owner,
 * 29 October 2026): connecting Google and subscribing in Apple Calendar draws every session twice.
 * The Google section is on screen once its read has a state to draw: `null` is the wait or the
 * error, and `unavailable` an environment without Google (the tab itself goes).
 */
export function pickOneCalendarNoteShown(
  google: GoogleCalendarView | null,
  apple: AppleCalendarView,
): boolean {
  return google !== null && google.kind !== 'unavailable' && apple.kind === 'offer';
}
